<!--
 * @Descripttion: 
 * @Author: zhongbin.chen
 * @Date: 2021-11-02 19:00:09
-->
<template>
	<div>
      <div id="canvasBox" class="canvasBox">
        <canvas id="map-canvas"></canvas>
        <!-- <div class="zoom">
          <div class="add" @click="addScale"></div>
          <div class="reduce" @click="minScale"></div>
          <img src="@/assets/images/map/zoom.png" class="zoomImg" alt="">
        </div> -->
        <div class="topmap">
          <div @click="offmap" :style="{cursor:'pointer'}"><el-icon size="22"><ArrowLeft /></el-icon></div> <div>{{mapName}}</div><div> </div>
        </div>
        <div class="newbottomdiv">
          <div v-show="textshowdownup"><img  @click="textshows(false)" src="@/assets/images/map/textnone.png" alt="" class="newbtnimg"></div>
          <div v-show="!textshowdownup"><img  @click="textshows(true)" src="@/assets/images/map/textshow.png" alt="" class="newbtnimg"></div>
          <div v-show="!filtrateshow"><img @click="filtrateshow=true" src="@/assets/images/map/listoff.png" alt="" class="newbtnimg"></div>
          <div v-show="filtrateshow"><img @click="filtrateshow=false" src="@/assets/images/map/liston.png" alt="" class="newbtnimg"></div>
          <div><img @click="addScale" src="@/assets/images/map/magnify.png" alt="" class="newbtnimg"></div>
          <div><img @click="minScale"  src="@/assets/images/map/lessen.png" alt="" class="newbtnimg"></div>
          <div><img  @click="restorationbtn" src="@/assets/images/map/restoration.png" alt="" class="newbtnimg"></div>
          <div><img @click="setboxmap" src="@/assets/images/map/fullscreen.png" alt="" class="newbtnimg">
          </div>
        </div>
        <div v-show="filtrateshow" class="listclass">
           <div>
               <el-checkbox v-model="ArrayAll" :label="$t('public.all')" size="large" @change="allchange" />
           </div>
           <div>
               <el-checkbox v-model="destinationstate" :label="$t('disinfect.destination')" size="large" @change="destinationchange" />
           </div>
           <div>
               <el-checkbox v-model="trackstate" :label="$t('map.tracks')" size="large" @change="trackstatechange" />
           </div>
           <div>
               <el-checkbox v-model="wallsstate" :label="$t('map.VirtualWall')" size="large"  @change="wallsstatechange" />
           </div>
           <div>
               <el-checkbox v-model="qrcodestate" :label="$t('map.Qrcode')" size="large" @change="qrcodestatechange" />
           </div>
           <div>
               <el-checkbox v-model="regionstate" :label="$t('map.regions')" size="large" @change="regionstatechange" />
           </div>
           <div>
               <el-checkbox v-model="anchorpointstate" :label="$t('map.anchorpoints')" size="large" @change="anchorpointstatechange" />
           </div>
        </div>
      </div>
	</div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  reactive,
  watch,
  ref,
  nextTick,
	toRefs,
	unref,
} from 'vue'
import { ElMessageBox, ElMessage, ElForm  } from 'element-plus';
import { totalImg } from '@/utils/robot' 
import { stat } from 'fs';
import i18n from '@/locales/index'
import { fabric } from "fabric";
let _t = i18n.global.t

export default {
  props: ['mapInfo', 'width', 'height','mapinfos'],
  emits:['boxmapfntrue','colsemaps'],
  setup(props,{emit}) {
    let canvas = '';
    let mapScale = 1;
    let mapOriginScale = 1;
    let isMouseDown = false;
    let lastPosition = {
      x: '',
      y: ''
    };
    const state = reactive({
      totalImg: totalImg(),
      mapName: props.mapinfos.map_name,
      width: props.width,
      height: props.height,
      mapInfo: props.mapinfos.info,
      textshowdownup:false,
      filtrateshow:false,
      ArrayAll:true,
      destinationstate:true,
      trackstate:true,
      wallsstate:true,
      qrcodestate:true,
      regionstate:true,
      anchorpointstate:true,
      allnumber:6
    });
    const methods = reactive({ 
    // 全部信息地图
    allchange(){
      let items = canvas.getObjects();
      if (state.ArrayAll) {
        state.allnumber = 6
        state.destinationstate = true
        state.trackstate = true
        state.wallsstate = true
        state.qrcodestate = true
        state.regionstate = true
        state.anchorpointstate = true
       items.map((ele,index)=>{
        canvas.getActiveObject(items[index].set('opacity', 1).setCoords())
      })
      } else {
        state.allnumber = 0
        state.destinationstate = false
        state.trackstate = false
        state.wallsstate = false
        state.qrcodestate = false
        state.regionstate = false
        state.anchorpointstate = false
        items.map((ele,index)=>{
        canvas.getActiveObject(items[index].set('opacity', 0).setCoords())
      })
      }
      canvas.renderAll();
    },
    // 区域显示隐藏
    regionstatechange() {
        let items = canvas.getObjects();
        // 区域包含三个信息
        methods.getmaptype(items,['slope_zone','safe_zone','slow_zone'],state.regionstate)
    },
    // 关于位置点显示隐藏
    destinationchange() {
        let items = canvas.getObjects();
        // 位置点包含五个点位的信息
        methods.getmaptype(items,['destination','charge','welcome','dining','recycle'],state.destinationstate)
    },
    // 轨道显示隐藏
    trackstatechange(){
      let items = canvas.getObjects();
       methods.getmaptype(items,'guideway',state.trackstate)
    },
    // 虚拟墙显示隐藏
    wallsstatechange(){
       let items = canvas.getObjects();
       methods.getmaptype(items,'wallLine',state.wallsstate)
    },
    // 二维码显示隐藏
    qrcodestatechange() {
        let items = canvas.getObjects();
         methods.getmaptype(items,'qrcode',state.qrcodestate)
    },
    // 定位点显示隐藏
    anchorpointstatechange(){
        let items = canvas.getObjects();
         methods.getmaptype(items,'anchor_point',state.anchorpointstate)
    },
    // 通用函数 判断是否显示 数字+-
    getmaptype(lists,type,bols){
        if (bols) {
          // true + 1 false -1
           state.allnumber++
           // 判断 type是否为数组和字符串 数组则便利所有 注 位置点包含 五个 区域包括三个 需要传递数组
           if (typeof type == 'string') {
               lists.map((ele,index)=>{
              if (ele.type == type ) {
                 canvas.getActiveObject(ele.set('opacity', 1).setCoords())
             }
           })
           } else {
            type.map((typeele)=>{
              lists.map((ele,index)=>{
              if (ele.type == typeele ) {
                 canvas.getActiveObject(ele.set('opacity', 1).setCoords())
             }
            })
           })
           }
        } else {
          state.allnumber--
          if (typeof type == 'string') {
               lists.map((ele,index)=>{
              if (ele.type == type ) {
                 canvas.getActiveObject(ele.set('opacity', 0).setCoords())
             }
           })
           } else {
            type.map((typeele)=>{
              lists.map((ele,index)=>{
              if (ele.type == typeele ) {
                 canvas.getActiveObject(ele.set('opacity', 0).setCoords())
             }
            })
           })
           }
        }
        // 为6为全选 否则相反
        if (state.allnumber == 6) {
          state.ArrayAll = true
        } else {
          state.ArrayAll = false
        }
        canvas.renderAll();
    },
    // 关闭小地图
     offmap() {
       emit('colsemaps')
     },
     // 打开全屏地图 设置参数 阻止俩边都监听滚动事件
     setboxmap() {
       localStorage.setItem('boxmapshow','1')
       emit('boxmapfntrue')
     },
     textshows(bol) {
         if (bol == state.textshowdownup) {
           return
         }
         state.textshowdownup = bol
        canvas.forEachObject((obj) => {
              // console.log(obj)
                     if (obj && obj.type&&(obj.type == 'nav'||obj.type == 'locotion'||obj.type == 'charge'||obj.type == 'destination'||obj.type == 'dining'||obj.type == 'welcome'||obj.type == 'recycle'||obj.type == 'anchor_point'||obj.type=='qrcode')) {
                      // console.log(obj.getObjects()[1].getActiveObject)
                      // obj.getObjects()[1].
                      // canvas.remove(obj)
                      // canvas.renderAll()
                      // 与以前代码逻辑冲突 代码重构 此重构方法更优
                      if (!state.textshowdownup) {
                        canvas.getActiveObject(obj.getObjects()[1].set('opacity', 1).setCoords())
                      } else {
                        canvas.getActiveObject(obj.getObjects()[1].set('opacity', 0).setCoords())
                      }
                    }
                });
                canvas.renderAll()
          // methods.setPoint(state.mapInfo.info,state.mapInfo.point)
      },
      openMap() {
        let detail = JSON.parse(JSON.stringify(props.mapinfos))
        detail.point = detail.point ? detail.point : []
        detail.wall = detail.wall ? JSON.parse(detail.wall) : []
        detail.guide_way = detail.guide_way?JSON.parse(detail.guide_way): []
        detail.info = detail.info
        detail.zones = detail.zones?JSON.parse(detail.zones):[]
        state.mapInfo = detail
        methods.setCanvas(state.mapInfo)
      },
      setCanvas(obj) {
        canvas = new fabric.Canvas('map-canvas', {
          // backgroundColor: '#DDF0F9',
          width: state.width,
          height: state.height,
          selectable: false
        });
        methods.setBgImg(obj)
      },
      bindEvents() {
        canvas.on({
          'mouse:down': methods.handleOnMouseDown,
          'mouse:move': methods.handleOnMouseMove,
          'mouse:up': methods.handleOnMouseUp,
          'mouse:wheel': methods.getgunlun
        });
        canvas.getZoom = function (params) {
          const { scaleX } = fabric.util.qrDecompose(this.viewportTransform);
          return scaleX;
        };
      },
      // 监听按键
      keydowns(keyCODEs){
        // 鼠标拖动图片的时候禁止按键移动
         if (isMouseDown||localStorage.getItem('boxmapshow')) {
          return
        }
         const vpt = canvas.viewportTransform.slice(0);
        if (keyCODEs == 37) {
          vpt[4] -= 5;
        } else if (keyCODEs == 39) {
          vpt[4] += 5;
        } else if (keyCODEs == 38) {
          vpt[5] -= 5;
        } else if (keyCODEs == 40) {
          vpt[5] += 5;
        }

        canvas.setViewportTransform(vpt);
        canvas.requestRenderAll();
      },
      // 滚轮事件 //
      getgunlun(opt) {
         let delta = opt.e.deltaY // 滚轮向上滚一下是 -100，向下滚一下是 100
         methods.scale_canvas(delta,opt.e.offsetX, opt.e.offsetY)
      },
      handleOnMouseDown(opt) {
        let hasMoved = false
        const { absolutePointer } = opt;
        lastPosition = {
          x: absolutePointer.x,
          y: absolutePointer.y
        }
        let mouseFrom = opt.absolutePointer
        isMouseDown = true
      },
      handleOnMouseUp() {
        isMouseDown = false
      },
      handleOnMouseMove(opt) {
        if (!isMouseDown) {
          return
        }
        const { absolutePointer } = opt;
        const { x, y } = lastPosition;
        let px = absolutePointer.x - x;
        let py = absolutePointer.y - y;

        const vpt = canvas.viewportTransform.slice(0);
        vpt[4] += px;
        vpt[5] += py;

        canvas.setViewportTransform(vpt);
        canvas.requestRenderAll();
      },
      setBgImg(obj) {
        const canvasBox = document.getElementById('canvasBox');
        fabric.Image.fromURL(obj.png_url?obj.png_url:'data:image/png;base64,' + obj.png_map, (img) => {
          // 背景图置于画布(0.0)，通过缩放调整画布,使背景图全图在页面中间
          img.set({
            left: 0,
            top: 0
          });
          const clientWidth = state.width
          const clientHeight = state.height
          const { width, height } = img;
          let scaleX = clientWidth / width;
          let scaleY = clientHeight / height;
          let scale = scaleX <= scaleY ? scaleX : scaleY;
          const left = (clientWidth - width) / 2;
          const top = (clientHeight - height) / 2;
          canvas.setViewportTransform([1, 0, 0, 1, left, top]); // [宽缩放倍数, x轴翻转角度, y轴翻转角度, 高缩放倍数, x, y]]
          canvas.zoomToPoint({
            x: clientWidth / 2,
            y: clientHeight / 2
          }, scale);
          
          mapOriginScale = scale
          mapScale = scale
          canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas));
          obj.zones && obj.zones.length>0 ? methods.setzones(obj.info, obj.zones) : null
          methods.setPoint(obj.info, obj.point)
          obj.wall && obj.wall.length>0 ? methods.setLine(obj.info, obj.wall) : null
          obj.guide_way && obj.guide_way.length>0 ? methods.setguideway(obj.info, obj.guide_way) : null
          methods.bindEvents()
        });
      },
      setzones(info, safeList) {
        console.log(safeList)
        if (safeList.length>0) {
          // 查询该数组是否有数据
           safeList.map((ele,index)=>{
              // 判断是哪种类型给它画矩形
             if (ele.type == 'slope_zone') {
            //  const newlist = ele.data.length>0 ? ele.data.map((one, i) => {return methods.safeinfo(one, i, info)}) : []
            //  console.log(newlist)
                methods.setzonestype(ele,'rgba(245,74,69,0.4)',info)
              } else if (ele.type == 'safe_zone') {
                methods.setzonestype(ele,'rgba(32,183,89,0.4)',info)
              } else if (ele.type == 'slow_zone') {
                methods.setzonestype(ele,'rgba(245,208,30,0.6)',info)
              }
           })
        }
      },
      setzonestype(ele,bgcolor,info) {
         const newlist = ele.data.length>0 ? ele.data.map((one, i) => {return methods.safeinfo(one, i, info)}) : []
          let newlistsafe = []
          let safalist = []
          newlist.map((ele,eleindex)=>{
            if (eleindex%2==0) {
              newlistsafe.push({
                x:ele
              })
            } else {
              newlistsafe.push({
                y:ele
              })
            }
          })
         
         newlistsafe.forEach((safeele,index)=>{
            if (index%2==0) {
              safalist.push(Object.assign(safeele,newlistsafe[index+1]))
            }
          })
          console.log(safalist)
         var rect =  new fabric.Polygon(safalist, { 
            fill: bgcolor, // 填充色
            stroke: '#fff', // 线段颜色：紫色
            strokeWidth: 0, // 线段粗细 5
            selectable: false
          })
          rect.set('type', ele.type)
          canvas.add(rect);
      },
      safeinfo(point,i,mapInfo) {
       const isX = i%2==0 // 判断是x还是y
        return isX ? (point - mapInfo.origin.x) / mapInfo.resolution  : 
        -((point - mapInfo.origin.y) / mapInfo.resolution - mapInfo.height)
        // (point*mapInfo.resolution - mapInfo.origin.x) / mapInfo.resolution  : 
        //        mapInfo.height - 1 - (point*mapInfo.resolution - mapInfo.origin.y) / mapInfo.resolution
     },
      setPoint(info, pointList) {
        // console.log(info,pointList,'绘点')
        pointList.length>0 ? pointList.forEach((point, index) => {
            let rawInfo = {
              "x": point.x,
              "y": point.y,
              "theta": point.theta,
              "orient_w": 0,
              "orient_z": 0
            }
            let pixInfo = methods.makePixInfo(rawInfo, info)
            if(point.action === "nav") {
              methods.addNavPoint(
                pixInfo.x,
                pixInfo.y,
                pixInfo.angle,
                point.idx,
                'nav',
                rawInfo
              )
            } else if (point.action === 'locotion') {
              methods.addUvPoint(
                pixInfo.x,
                pixInfo.y,
                pixInfo.angle,
                point.mark,
                'locotion',
                rawInfo
              )
            } else if (point.action === 'charge') {
               methods.addBatteryPoint(
                pixInfo.x,
                pixInfo.y,
                pixInfo.angle,
                // point.idx,
               point.mark,
                'charge',
                rawInfo
              )
            } else if (point.action === 'destination') {
              methods.addUvPoint(
                pixInfo.x,
                pixInfo.y,
                pixInfo.angle,
                point.mark,
                'destination',
                rawInfo
              )
            }
             else if (point.action == 'dining') {
              methods.adddiningPoint(
                pixInfo.x,
                pixInfo.y,
                pixInfo.angle,
                point.mark,
                'dining',
                rawInfo
              )
            } else if (point.action == 'welcome') {
              methods.adddwelcomePoint(
                pixInfo.x,
                pixInfo.y,
                pixInfo.angle,
                point.mark,
                'welcome',
                rawInfo
              )
            } else if (point.action == 'recycle') {
               methods.adddrecyclePoint(
                pixInfo.x,
                pixInfo.y,
                pixInfo.angle,
                point.mark,
                'recycle',
                rawInfo
              )
            } else if (point.action == 'qrcode') {
              methods.adddqrcodeePoint(
                pixInfo.x,
                pixInfo.y,
                pixInfo.angle,
                point.mark,
                'qrcode',
                rawInfo
              )
            }
            if (point.action == 'anchor_point') {
              methods.adddanchorPoint(
                pixInfo.x,
                pixInfo.y,
                pixInfo.angle,
                point.mark,
                'anchor_point',
                rawInfo
              )
            }
        }) : null
      },
      setguideway(info, wallList) {
          wallList.forEach((item, index) => {
          const newlist = item.data.length>0 ? item.data.map((one, i) => {return methods.makeWallInfo(one, i, info)}) : []
          // console.log(newlist)
          let newlistsafe = []
          let safalist = []
          newlist.map((ele,eleindex)=>{
            if (eleindex%2==0) {
              newlistsafe.push({
                x:ele
              })
            } else {
              newlistsafe.push({
                y:ele
              })
            }
          })
         
         newlistsafe.forEach((safeele,index)=>{
            if (index%2==0) {
              safalist.push(Object.assign(safeele,newlistsafe[index+1]))
            }
          })
          var rect = new fabric.Polyline(safalist, {
              fill: 'transparent', // 如果画折线，需要填充透明
              stroke: '#2824DB', // 线段颜色：灰色
              strokeWidth: 2,
              selectable:false,
          })
          rect.set('type', 'guideway')
          canvas.add(rect);
        })
      },
      setLine(info, wallList) {
        wallList.forEach((item, index) => {
          const newlist = item.data.length>0 ? item.data.map((one, i) => {return methods.makeWallInfo(one, i, info)}) : []
          // console.log(newlist)
          let newlistsafe = []
          let safalist = []
          newlist.map((ele,eleindex)=>{
            if (eleindex%2==0) {
              newlistsafe.push({
                x:ele
              })
            } else {
              newlistsafe.push({
                y:ele
              })
            }
          })
         
         newlistsafe.forEach((safeele,index)=>{
            if (index%2==0) {
              safalist.push(Object.assign(safeele,newlistsafe[index+1]))
            }
          })
          var rect = new fabric.Polyline(safalist, {
              fill: 'transparent', // 如果画折线，需要填充透明
              stroke: '#333333', // 线段颜色：灰色
              strokeWidth: 2,
              selectable:false,
              strokeDashArray: [6, 1]
          })
          rect.set('type', 'wallLine')
          canvas.add(rect);
        })
      },
      adddqrcodeePoint(x, y, angle, index, type, rawInfo) {
        fabric.Image.fromURL(require('@/assets/images/map/QRcode.png'), (img) => {
          let img1 = img.scale(0.6).set({
            left: 0,
            top: 0,
            originX: 'center',
            originY: 'center'
          });
          let text = new fabric.Text(state.textshowdownup?'':index + '', {
            fontSize: 14,
            originX: 'center',
            originY: 'center',
            fill: "#05B4BC",
            fontStyle: 'normal',
            backgroundColor:'',
            top: -20,
          });
          let group = new fabric.Group([img1,text], {
            originX: 'center',
            originY: 'center',
            left: x,
            top:y-7/mapScale,
            angle: 0,
            lockMovementX: true,
            lockMovementY: true
          });
          group.set("type", type)
          group.set("idx", index)
          group.set("rawInfo", rawInfo)
          group.set("selectable", false)
          group.scale(1 / mapScale)
          canvas.add(group);
        });
      },
      adddanchorPoint(x, y, angle, index, type, rawInfo) {
        fabric.Image.fromURL(require('@/assets/images/map/anchor.png'), (img) => {
          let img1 = img.scale(0.6).set({
            left: 0,
            top: 0,
            originX: 'center',
            originY: 'center'
          });
          let text = new fabric.Text(state.textshowdownup?'':index + '', {
            fontSize: 14,
            originX: 'center',
            originY: 'center',
            fill: "#05B4BC",
            fontStyle: 'normal',
            backgroundColor:'',
            top: -20,
          });
          let group = new fabric.Group([img1,text], {
            originX: 'center',
            originY: 'center',
            left: x,
            top:y-7/mapScale,
            angle: 0,
            lockMovementX: true,
            lockMovementY: true
          });
          group.set("type", type)
          group.set("idx", index)
          group.set("rawInfo", rawInfo)
          group.set("selectable", false)
          group.scale(1 / mapScale)
          canvas.add(group);
        });
      },
      addNavPoint(x, y, angle, index, type, rawInfo) {
        fabric.Image.fromURL(require('@/assets/images/map/nav.png'), (img) => {
          let img1 = img.scale(0.6).set({
            left: 0,
            top: 0,
            originX: 'center',
            originY: 'center'
          });
          let text = new fabric.Text(index + '', {
            fontSize: 16,
            originX: 'center',
            originY: 'center',
            fill: "#8C8C8C",
            fontStyle: 'normal',
            backgroundColor:'red'
          });
          let group = new fabric.Group([img1, text], {
            originX: 'center',
            originY: 'center',
            left: x,
            top: y,
            angle: 0,
            lockMovementX: true,
            lockMovementY: true
          });
          group.set("type", 'nav')
          group.set("idx", index)
          group.set("rawInfo", rawInfo)
          group.set("selectable", false)
          group.scale(1 / mapScale)
          canvas.add(group);
        });
      },
      addtextsboder(x, y,angle, index, type, rawInfo) {
        console.log(x,y,index,rawInfo)
           let text = new fabric.Textbox(index + '', {
            fontSize: 12,
            originX: 'center',
            originY: 'center',
            fill: "rgba(0,0,0,0.85)",
            fontStyle: 'normal',
            color:'',
            backgroundColor:'#ffffff',
            left: x,
            top: y-16,
            angle: 0,
            lockMovementX: true,
            lockMovementY: true,
            padding:100
          });
          text.set("type", 'texts')
          text.set("idx", index)
          text.set("rawInfo", rawInfo)
          text.set("selectable", false)
          text.scale(1 / mapScale)
          canvas.add(text);
      },
      adddrecyclePoint(x, y, angle, index, type, rawInfo) {
        fabric.Image.fromURL(require('@/assets/images/map/recycle.png'), (img) => {
          let img1 = img.scale(0.6).set({
            left: 0,
            top: 0,
            originX: 'center',
            originY: 'center'
          });
          let text = new fabric.Text(state.textshowdownup?'':index + '', {
            fontSize: 14,
            originX: 'center',
            originY: 'center',
            fill: "#05B4BC",
            fontStyle: 'normal',
            backgroundColor:'',
            top: -20,
          });
          let group = new fabric.Group([img1,text], {
            originX: 'center',
            originY: 'center',
            left: x,
            top:y-7/mapScale,
            angle: 0,
            lockMovementX: true,
            lockMovementY: true
          });
          group.set("type", type)
          group.set("idx", index)
          group.set("rawInfo", rawInfo)
          group.set("selectable", false)
          group.scale(1 / mapScale)
          canvas.add(group);
        });
      },
      adddwelcomePoint(x, y, angle, index, type, rawInfo) {
        fabric.Image.fromURL(require('@/assets/images/map/welcome.png'), (img) => {
          let img1 = img.scale(0.6).set({
            left: 0,
            top: 0,
            originX: 'center',
            originY: 'center'
          });
          let text = new fabric.Text(state.textshowdownup?'':index + '', {
            fontSize: 14,
            originX: 'center',
            originY: 'center',
            fill: "#05B4BC",
            fontStyle: 'normal',
            backgroundColor:'',
            top: -20,
          });
          let group = new fabric.Group([img1,text], {
            originX: 'center',
            originY: 'center',
            left: x,
            top:y-7/mapScale,
            angle: 0,
            lockMovementX: true,
            lockMovementY: true
          });
          group.set("type", type)
          group.set("idx", index)
          group.set("rawInfo", rawInfo)
          group.set("selectable", false)
          group.scale(1 / mapScale)
          canvas.add(group);
        });
      },
      adddiningPoint(x, y, angle, index, type, rawInfo) {
        fabric.Image.fromURL(require('@/assets/images/map/dining.png'), (img) => {
          let img1 = img.scale(0.6).set({
            left: 0,
            top: 0,
            originX: 'center',
            originY: 'center'
          });
          let text = new fabric.Text(state.textshowdownup?'':index + '', {
            fontSize: 14,
            originX: 'center',
            originY: 'center',
            fill: "#05B4BC",
            fontStyle: 'normal',
            backgroundColor:'',
            top: -20,
          });
          let group = new fabric.Group([img1,text], {
            originX: 'center',
            originY: 'center',
            left: x,
            top:y-7/mapScale,
            angle: 0,
            lockMovementX: true,
            lockMovementY: true
          });
          group.set("type", type)
          group.set("idx", index)
          group.set("rawInfo", rawInfo)
          group.set("selectable", false)
          group.scale(1 / mapScale)
          canvas.add(group);
        });
      },
      addUvPoint(x, y, angle, index, type, rawInfo) {
        fabric.Image.fromURL(require('@/assets/images/map/newposition.png'), (img) => {
          let img1 = img.scale(0.6).set({
            left: 0,
            top: 0,
            originX: 'center',
            originY: 'center'
          });
          let text = new fabric.Text(state.textshowdownup?'':index + '', {
            fontSize: 14,
            originX: 'center',
            originY: 'center',
            fill: "#05B4BC",
            fontStyle: 'normal',
            backgroundColor:'',
            top: -20,
          });
          let group = new fabric.Group([img1,text], {
            originX: 'center',
            originY: 'center',
            left: x,
            top:y-7/mapScale,
            angle: 0,
            lockMovementX: true,
            lockMovementY: true
          });
          group.set("type", type)
          group.set("idx", index)
          group.set("rawInfo", rawInfo)
          group.set("selectable", false)
          group.scale(1 / mapScale)
          canvas.add(group);
        });
      },
      addBatteryPoint(x, y, angle, index, type, rawInfo) {
        fabric.Image.fromURL(require('@/assets/images/map/newbattery.png'), (img) => {
          let img1 = img.scale(0.6).set({
            left: 0,
            top: 0,
            originX: 'center',
            originY: 'center'
          });
          let text = new fabric.Text(state.textshowdownup?'':index+'', {
            fontSize: 14,
            originX: 'center',
            originY: 'center',
            fill: "#05B4BC",
            fontStyle: 'normal',
            backgroundColor:'',
            top: -20,
          });
          let group = new fabric.Group([img1,text], {
            originX: 'center',
            originY: 'center',
            left: x,
            top:y-7/mapScale,
            angle: 0,
            lockMovementX: true,
            lockMovementY: true
          });
          group.set("type", type)
          group.set("idx", index)
          group.set("rawInfo", rawInfo)
          group.set("selectable", false)
          group.scale(1 / mapScale)
          canvas.add(group);
        });
      },
      //计算每个点位的横像素坐标
      calcX(item, mapInfo) {
        let wid = ((item.x - mapInfo.origin.x) / mapInfo.resolution)
        return wid
      },
      //计算每个点位的纵像素坐标
      calcY(item, mapInfo) {
        // let hei = mapInfo.height - 1 - ((item.y - mapInfo.origin.y) / mapInfo.resolution)
        let hei = (mapInfo.height  -((item.y - mapInfo.origin.y) )/ mapInfo.resolution)
        return hei
      },
      makePixInfo(rawPos, mapInfo) {
        return {
          x: methods.calcX(rawPos, mapInfo),
          y: methods.calcY(rawPos, mapInfo),
          angle: 0
        }
      },
      makeWallInfo(point, i, mapInfo) {
        const isX = i%2==0 // 判断是x还是y
        return isX ? (point- mapInfo.origin.x) / mapInfo.resolution  : 
               mapInfo.height  - (point- mapInfo.origin.y) / mapInfo.resolution
      },

      // 缩放
      addScale() {
        methods.scale_canvas(-100, state.width / 2, state.height / 2)
      },
      minScale() {
        methods.scale_canvas(100, state.width / 2, state.height / 2)
      },
      restorationbtn() {
        // methods.scale_canvas(100*100, state.width / 2, state.height / 2)
       // 重置所有状态相当于重新打开地图
       methods.closeCanvas()
       state.textshowdownup = false
       state.filtrateshow=false,
       state.ArrayAll=true,
       state.destinationstate=true,
       state.trackstate=true,
       state.wallsstate=true,
       state.qrcodestate=true,
       state.regionstate=true,
       state.anchorpointstate=true,
       state.allnumber=6
       methods.openMap()
      },
      scale_canvas(deltaY, offsetX, offsetY) {
        let zoom = canvas.getZoom();
        zoom *= 0.999 ** deltaY; // 两个*表示幂运算
        if (zoom > parseInt(1/state.mapInfo.info.resolution))
          zoom = parseInt(1/state.mapInfo.info.resolution);
        if (zoom < mapOriginScale)
          zoom = mapOriginScale;
        canvas.zoomToPoint({
          x: offsetX,
          y: offsetY
        }, zoom);
        mapScale = zoom
        methods.updatePointsPostion()
      },
      //因为地图大小实时变化，点位的坐标也要更新
      updatePointsPostion() {
        canvas.forEachObject((obj, i) => {
          if (obj && obj.type && (obj.type === 'destination'||obj.type === 'charge'||obj.type === 'welcome'||obj.type === 'dining'||obj.type === 'recycle'||obj.type === 'anchor_point'||obj.type=='qrcode') ) {
              let rawInfo = obj.rawInfo
              let mapPos = {
              "x": rawInfo.x,
              "y": rawInfo.y,
              "theta": rawInfo.theta
            }
            let pixPos = methods.makePixInfo(mapPos, state.mapInfo.info)
            obj.top = pixPos.y-7/mapScale
            obj.scale(1/ mapScale)
          }
        });
      },

      closeCanvas() {
        if(canvas) {
          canvas.clear()
          canvas.setViewportTransform([1, 0, 0, 1, 0, 0])
          canvas.dispose() // 清除初始化创建的canvas等element
        }
      },

		})
    onMounted(() => {
      methods.openMap()
      console.log('获取地图数据',props.mapinfos,state.mapName)
      
     document.addEventListener('keydown', function(e) {
	//         switch (e.keyCode) {
	// 	case 37:
	// 		console.log("左");
	// 		break;
	// 	case 38:
	// 		console.log("上");
	// 		break;
	// 	case 39:
	// 		console.log("右");
	// 		break;
	// 	case 40:
	// 		console.log("下");
	// 		break;
	// }
  if (e.keyCode == 37||e.keyCode ==38||e.keyCode ==39||e.keyCode ==40) {
    methods.keydowns(e.keyCode)
  }
})



    })
    
    return {
      ...toRefs(state),
      ...toRefs(methods),
    }
  }
}
</script>

<style lang="scss" scoped>
.canvasBox{
  margin-right: 10px;
  width: 100%;
  height: 100%;
  position: relative;
  .topmap{
    position: absolute;
    display: flex;
    justify-content: space-between;
    top: 14px;
    width: 100%;
    height: 30px;
    padding: 0 20px;
    font-size: 22px;
  }
  .zoom{
    position: absolute;
    left: 10px;
    bottom: 5px;
    width: 106px;
    height: 54px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    z-index: 300;
    cursor: pointer;
    .reduce,
    .add {
      width: 50%;
      z-index: 301;
    }
    .zoomImg {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 106px;
      height: 54px;
    }
  }
 .newbottomdiv{
  // display: flex;
  // align-items: center;
  position: absolute;
  bottom: 20px;
  right: 20px;
   .newbtnimg{
     width: 36px;
     height: 36px;
     margin: 0 5px;
     cursor: pointer;
 }
  .zommright{
    border: 1px solid rgba(0,0,0,0.8);
    cursor: pointer;
    color: rgba(0,0,0,0.8);;
    padding: 7px 12px;
    margin-left: auto;
    border-radius: 5px;
 }
 }
 .listclass{
  position: absolute;
  bottom: 20px;
  right: 90px;
  padding: 0 20px;
  background: #ffffff;
  border-radius: 15px;
  >div{
    height: 35px;
    line-height: 35px;
  }
 }
}


</style>
